// extracted by mini-css-extract-plugin
module.exports = {"root":"SlideInSidebar_root__n8HL_","overlay":"SlideInSidebar_overlay__9ru86","sidebar":"SlideInSidebar_sidebar__gb09Q","close":"SlideInSidebar_close__3VfjR"};